import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs/internal/Observable';
import { map, startWith } from 'rxjs/operators';
import { ApiService } from 'src/app/Services/api.service';
import { RouteService } from 'src/app/Services/route.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

@Component({
  selector: 'app-add-regular-manual-rostering',
  templateUrl: './add-regular-manual-rostering.component.html',
  styleUrls: ['./add-regular-manual-rostering.component.css']
})
export class AddRegularManualRosteringComponent implements OnInit {

/* dropdown search filter*/
  @ViewChild('search', {static: true}) searchTextBox: ElementRef;
  searchTextboxControl = new FormControl();
  data: any = [];
  filteredOptions: Observable<any[]>;

  public routeForm:FormGroup;
  public secondFormGroup:FormGroup;
  public thirdFormGroup:FormGroup
  public isLinear=true;

  public userData;

/* Api objects */

  public routeObj=[];
  public shiftObj=[];
  public vehicleObj=[];
  public branchInformation=[];
  
/* Route form data*/
  public routeFormInformation={};
  
/* pickup point */
  public pickupPointsPage:boolean=false;
  public vehicleList=[];

  public startTime = { hour: 0, minute: 0, meriden: 'AM', format: 12, val: 'startData' };
  public endTime = { hour: 0, minute: 0, meriden: 'AM', format: 12, val: 'startData' };
  public modifiedStartTime;
  public modifiedEndTime;

  public selectedShift;
  public shiftwiseRoute;
  
  public fieldOptions = [{
    routeType: ['pickup', 'drop'],
    routeShift: [],
    notification:['push','sms','email','ivr calls'],
    branch: [],
    pickupPointAttendance:['OTP','Beacon','Wifi','RFID'],
    vehicles:[],
  }];

  constructor(
    public api: ApiService,
    public swal: SweetAlert,
    private fb: FormBuilder,
    public storage: StorageService,
    public routeGenerate: RouteService,
    ) {
    this.userData = this.storage.get('userInfo',)

   }

  ngOnInit(): void {
    this.createRouteForm();
    this.getListShift();
    this.getBranchList();
    this.getVehicleList();
    this.getRouteData();

/* Set filter event based on value changes */
      this.filteredOptions = this.searchTextboxControl.valueChanges
      .pipe(
        startWith<string>(''),
        map(name => this._filter(name))
      );
    
    this.secondFormGroup=this.fb.group({
      pickupPoint:[''],
    })
  }
/* Used to filter data based on search input */
  private _filter(name: string): String[] {
    const filterValue = name.toLowerCase();
    const filteredList = this.data.filter(option => option.vehRegNo.toLowerCase().indexOf(filterValue) === 0);
    return filteredList;
  }

/* Remove from selected values based on uncheck */
  selectionChange(event) {
    if (event.isUserInput && event.source.selected == false) {
      const index = this.routeForm.controls.vehicles.value.indexOf(event.source.value);
      this.routeForm.controls.vehicles.value.splice(index, 1);
    }
  }

  openedChange(e) {
    // Set search textbox value as empty while opening selectbox
    this.searchTextboxControl.patchValue('');
    // Focus to search textbox while clicking on selectbox
    if (e == true) {
      this.searchTextBox.nativeElement.focus();
    }
  }

/* Clearing search textbox value */
  clearSearch(event) {
    event.stopPropagation();
    this.searchTextboxControl.patchValue('');
  }
 
  routeFormData(){
    console.log('route form values',this.routeForm.value);
  }

  createRouteForm(){
    this.routeForm=this.fb.group({
      routeName:['',[Validators.required]],
      branch:['',[Validators.required]],
      routeShift:['',[Validators.required]],
      routeTime:['',[Validators.required]],
      endTime:['',[Validators.required]],
      routeType:['',[Validators.required]],
      attendance:['',[Validators.required]],
      routeStatus:['',[Validators.required]],
      vehicles:['',[Validators.required]],
      ivrCalls:['',Validators.required],
    });
  }
/* API */
  getBranchList() {
    const obj = {
      orgID: this.storage.get('userInfo').orgID
    };
    this.api.transportManagerBranchList(obj).then((res: any) => {
      if (res.status == 'success') {
        this.branchInformation = res.data;
        this.addBranchOptions();
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  getRouteData() {
    let obj = {
      orgID: this.userData.orgID,
    };
    this.api.transportMangerRouteList(obj).then((res: any) => {
      if (res.status == 'success') {
        this.routeObj=res.data;
        this.getCabTable();
      } else {
        console.log('else', res);
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  getListShift() {
    let obj = {
      orgID: this.userData.orgID
    }
    this.api.ListShift(obj).then((res: any) => {
      if (res.status == 'success') {
        this.shiftObj = res.data;
      }
    }).catch((err) => {
      console.log(err)
    })
  }
  getVehicleList(){
    let obj = {
      orgID: this.userData.orgID,
    }
    this.api.transportManagerVehicleList(obj).then((res:any)=>{
      if (res.status == 'success') {
      this.vehicleObj=res.data;
      console.log(this.vehicleObj);
      this.data=res.data;
      this.searchTextboxControl.patchValue('');
      }
    }).catch((err) => {
      console.log(err)
    })
  }  
/* set branch options */
  addBranchOptions(){
    if(this.branchInformation && this.branchInformation.length>0){
      this.branchInformation.filter((e)=>{
        let option={name:e.branchName,value:e.branchID};
        this.fieldOptions[0].branch.push(option);
      });
    }
  }
/* get obj from id*/
getVehicleObj(id){
  let objId=[id];
  let obj=this.getObjData(this.vehicleObj,'vehicleID',objId);
  if(obj && obj[0]) return obj[0].vehRegNo;
  else return '';

}
getObjData(obj,typeOfID,id){
  let result=[];
  id.filter((val)=>{
    obj.filter((element)=>{
      if(element[typeOfID]==val){
        result.push(element);
      }
    })
  });
  return result;
}
/* Field Change */
  fieldChange(field,type,e:any){
    let value='';
    if(type=='dropdown'){
      if(field=='branch'&&e!=undefined){
        value=e;
        let filteredShift=this.shiftObj.filter((item)=>item.branch==e);
        let filteredShiftData=[];
        filteredShift.filter((item)=>{
          filteredShiftData.push(
          {shiftName:item.shiftName,
          shiftID:item.shiftID,
          }
          )});
        this.fieldOptions[0].routeShift=filteredShiftData;
      }
      if(field=='routeShift'){
        if(this.routeForm.controls.branch.errors==null){
          if(e.value!=undefined){
            value=e.value;
            this.selectedShift=e.value;
            let filteredShift=this.shiftObj.filter((item)=>item.shiftID==e.value);
            this.startTime=filteredShift[0].startTime;
            let changedHour;
            let changedMeriden = this.startTime.meriden;
            let assignedTime = Number(this.startTime.hour);

            if (assignedTime == 12) {
              changedHour = 11;
              if (this.startTime.meriden == 'AM') {
                changedMeriden = 'PM';
              }
              else if (this.startTime.meriden == 'PM') {
                changedMeriden = 'AM';
              }
            }
            else if (assignedTime == 1) {
              changedHour = 12;
            }
            else {
              changedHour = assignedTime - 1;
            }
            let changedTime = { hour: changedHour, minute: this.startTime.minute, meriden: changedMeriden, format: 12, val: 'startData' };
            this.startTime = changedTime;
            this.routeForm.controls['routeTime'].patchValue(this.startTime);
            this.onChangeHour(this.startTime, 'start-time');
          }
        }
        else if (this.routeForm.controls.branch.errors != null) {
          this.routeForm.controls.branch.markAsTouched();
        }
      }
    }
  }
  /* filter cabs */
  getCabTable() {
    let filteredCabsList = [];
    this.routeObj.filter((item) => {
      if (item.cabInfo) {
        item.cabInfo.filter((cab) => {
          if (filteredCabsList.indexOf(cab) == -1) {
            filteredCabsList.push(cab);
          }
        })
      }
    })
    let finalObj=[...this.vehicleObj];
      filteredCabsList.filter((item)=>{
        finalObj.filter((element,index)=>{
          if(item==element.vehicleID){
            finalObj.splice(index,1);
          }
        })
      })
      console.log(finalObj);
      this.fieldOptions[0].vehicles= finalObj;
     /*  this.data=finalObj;
      this.searchTextboxControl.patchValue(''); */
    }

  onChangeHour(event, val) {
    if (val == 'start-time') 
    { 
      this.startTime = event;
      this.modifiedStartTime= event.hour + ':' + event.minute + ' ' + event.meriden;
      if(Number(event.minute)<10){
        event.minute=event.minute.substring(1);
      }
      this.startTime = event;
    }
    if (val == 'end-time') 
    { 
      this.endTime = event;
      this.modifiedEndTime= event.hour + ':' + event.minute + ' ' + event.meriden;
      if(Number(event.minute)<10){
        event.minute=event.minute.substring(1);
      }
      this.endTime = event;
      this.routeForm.controls['endTime'].patchValue(this.endTime);
    }
  }
  sendFormData(){
    this.pickupPointsPage=false;
    if(this.routeForm.valid){
      this.setCabInfo();
      this.pickupPointsPage=true;
      this.routeFormInformation={
        cabInfo:this.vehicleList,
        ...this.routeForm.value,
        };
      /* if(this.modifiedEndTime!=undefined){
        this.routeFormInformation['endTime']=this.endTime;
      } */
    }
  }
  setCabInfo(){
    if(this.routeForm.controls.vehicles.value){
      this.vehicleList=[];
      let obj=[...this.vehicleObj];
      this.routeForm.controls.vehicles.value.filter((selectedCab)=>{
        obj.filter((cab)=>{
          if(selectedCab==cab.vehicleID){
            if(this.vehicleList.indexOf(cab.vehicleID)==-1){
              this.vehicleList.push(cab.vehicleID);
            }
          }
        })
      })
    }
  }
  stepChange(e){
    if(e.selectedIndex === 0){
      this.pickupPointsPage=false;
      if(this.routeForm.valid){
        this.setCabInfo();
        let finalFormData={
          cabInfo:this.vehicleList,
          ...this.routeForm.value,
        };
        if(finalFormData!=this.routeFormInformation){
          this.sendFormData();
        }
      }
    }
  }
}
